import moment from "moment";

export const calculateTimeDiff = (startTime, endTime, timeFormat) => {
  const start = moment(startTime);
  const end = moment(endTime);
  const diffTime = end.diff(start);
  return moment.utc(diffTime).format(timeFormat);
};

export const formatDateTime = (dateTime) => {
  return moment(dateTime)
    .locale("pt-br")
    .format("DD [de] MMMM [de] YYYY HH:mm:ss.SSS");
};

export const isMappableArray = (arr, callback) => {
  if (Array.isArray(arr) && arr.length > 0) {
    return arr.map(callback)
  } else {
    return null
  }
}

